import { makeQueryOptions } from '@mint-lib/api-zod-support/react-query';

import { defaultApi, defaultClient } from '@mint-sdk/api-core';

import {
  TaskBodySchema,
  TaskItemListSchema,
  TasksResponseSchema,
} from '../shared/schemas/tasks.js';

export const getTasksDeprecated = defaultApi.declareEndpoint({
  url: `ga4-service/v2/tasks/` as const,
  method: 'POST',
  responseSchema: TasksResponseSchema,
  requestSchema: TaskBodySchema,
});

export const getTasksQueryOptions = makeQueryOptions(getTasksDeprecated, {
  processResponse(data) {
    return data;
  },
});

export const getTasks = defaultClient.mutation({
  url: `ga4-service/v2/tasks/` as const,
  method: 'POST',
  responseSchema: TaskItemListSchema,
  requestSchema: TaskBodySchema,
  processResponse(data) {
    return data;
  },
});
